module.exports = __webpack_public_path__ + "static/media/sleep.2d784c15.svg";